// extracted by mini-css-extract-plugin
export default {"account-screen":"AccountScreen_account-screen__JrsIG","account-form":"AccountScreen_account-form__ppRQs","error":"AccountScreen_error__2Exdo"};